import React from 'react';
import classNames from 'classnames';

import css from './Input.css';

const Input = ({
  inputClassName,
  className,
  errorClassName,
  labelClassName,
  containerClassName,
  label = null,
  error = null,
  isValidation = true,
  markRequired = false,
  ...rest
}) => {
  const containerClasses = classNames(
    css.container,
    { [css.validation]: isValidation },
    containerClassName
  );
  const classes = classNames(inputClassName, css.input, className, { [css.inputError]: !!error });
  const labelClasses = classNames(css.text, labelClassName);
  const errorClasses = classNames(css.error, errorClassName);

  return (
    <div className={containerClasses}>
      <label className={css.label}>
        {label && (
          <span className={labelClasses}>
            {label}
            {markRequired && '*'}
          </span>
        )}
        <input className={classes} {...rest} />
      </label>
      {error && isValidation && <span className={errorClasses}>{error}</span>}
    </div>
  );
};

export default Input;
